import React, { useState } from "react";
// componentes
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Collapse,
} from "reactstrap";
import UploadComponent from "../../Apps/Personalization/UploadComponent";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// redux
import { useSelector } from "react-redux";
// services
import {
  getCertificateByName,
  newCertificate,
} from "../../../utils/services/certificate";
import { getUrlFiles } from "../../../utils/services/files";

export default function ModalNewCertificate(props) {
  const { token: jwt } = useSelector((state) => state.global_user_data.data);
  const { isOpen, toggle, eventId, refetch } = props;

  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [tags, setTags] = useState([]);
  const [image, setImage] = useState("");
  const [color, setColor] = useState("#ffffff");
  const [name, setName] = useState("");
  // configurações do nome dos participantes
  const [fontSize, setFontSize] = useState("");
  const [textAlignment, setTextAlignment] = useState("Selecione");
  const [heightPosition, setHeightPosition] = useState("");
  const [widthPosition, setWidthPosition] = useState("");
  //error state
  const [nameError, setNameError] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [fontSizeError, setFontSizeError] = useState(false);
  const [nameIsRegistered, setNameIsRegistered] = useState(false);
  const [heightError, setHeightError] = useState(false);
  const [widthError, setWidthError] = useState(false);
  const [alignError, setAlignError] = useState(false);
  // collapse
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);

  const [success, setSuccess] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // adiciona uma tag, sem duplicar
  function addTags(newTags) {
    setTags([...new Set([...tags, newTags])]);
  }

  // remove a tag da posição informada
  function removeTags(index) {
    const newTags = [...tags];
    newTags.splice(index, 1);
    setTags(newTags);
  }

  // valida o form, envia a imagem e cria o certificado
  async function submitForm(e) {
    e.preventDefault();

    if (!name) {
      setNameError(true);
      return;
    } else setNameError(false);

    if (!image) {
      setImageError(true);
      return;
    } else setImageError(false);

    if (!fontSize) {
      setCollapseIsOpen(true);
      setFontSizeError(true);
      return;
    } else setFontSizeError(false);

    if (textAlignment === "Selecione") {
      setCollapseIsOpen(true);
      setAlignError(true);
      return;
    } else setAlignError(false);

    if (!heightPosition) {
      setCollapseIsOpen(true);
      setHeightError(true);
      return;
    } else setHeightError(false);

    if (!widthPosition) {
      setCollapseIsOpen(true);
      setWidthError(true);
      return;
    } else setWidthError(false);

    try {
      const nameAlreadyExists = await getCertificateByName({
        jwt,
        eventId,
        name,
      });

      if (nameAlreadyExists.data.message === "CERTIFICATE_FOUND") {
        setNameIsRegistered(true);
        return;
      } else setNameIsRegistered(false);
    } catch (error) {
      console.error("Erro ao verificar nome do certificado:", error);
      setSubmitErrorMessage("Erro ao verificar o nome do certificado.");
      return;
    }

    const formData = new FormData();
    formData.append("files", image.files[0]);
    formData.append("name", name);
    formData.append("folder", "certificados");
    formData.append("eventId", eventId);

    let urlFile;
    let expireDate = null;
    let imageId = null;

    try {
      const response = await getUrlFiles(formData, jwt);
      response.forEach((file) => {
        urlFile = file.url;
        expireDate = file.expires;
        imageId = file.fileId;
      });
    } catch (error) {
      console.error("Erro ao enviar a imagem:", error);
      setSubmitErrorMessage("Erro ao enviar a imagem.");
      return;
    }

    const data = {
      name,
      imageId,
      eventId,
      image: urlFile,
      fontSize: +fontSize,
      textAlignment,
      heightPosition: +heightPosition,
      widthPosition: +widthPosition,
      color,
      expireImage: expireDate,
      tags: tags.map((tag) => ({ name: tag })),
    };

    setIsLoading(true);
    try {
      await newCertificate({ data, jwt });
      setSuccess(true);
      refetch();
    } catch (error) {
      console.error("Erro ao criar certificado:", error);
      setSubmitErrorMessage("Erro ao criar certificado.");
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleBackdrop()}
      autoFocus
      centered
      size="lg"
    >
      {success && (
        <SweetAlert
          success
          title="Criação de Certificado"
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          Certificado criado com sucesso!
        </SweetAlert>
      )}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title="Erro"
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Novo Certificado</ModalHeader>
      <ModalBody style={{ padding: 20 }}>
        <form onSubmit={submitForm}>
          <Row style={{ paddingLeft: 0, paddingRight: 0 }}>
            <label className="form-label" style={{ padding: 0 }}>
              Nome*
            </label>
            <input
              className="form-control"
              type="text"
              placeholder="Nome do certificado"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            {nameError && (
              <span className="text-danger">O campo Nome é obrigatório</span>
            )}
            {nameIsRegistered && (
              <span className="text-danger">
                Já existe um certificado com esse nome
              </span>
            )}
          </Row>
          <Row style={{ marginTop: 10 }}>
            <label className="form-label" style={{ padding: 0 }}>
              Tags
            </label>
            <input
              className="form-control"
              type="text"
              placeholder="Digite e pressione a tecla Enter para adicionar a Tag"
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value) {
                  e.preventDefault();
                  e.stopPropagation();

                  addTags(e.target.value);
                  e.target.value = "";
                }
              }}
            />
          </Row>
          {tags?.length > 0 && (
            <Row>
              <div className="tag-container" style={{ padding: 0 }}>
                {tags.map((tag, index) => (
                  <div key={index} className="tag-wrapper">
                    <span className="tags-field">{tag}</span>
                    <i
                      className="mdi mdi-close"
                      onClick={() => removeTags(index)}
                    />
                  </div>
                ))}
              </div>
            </Row>
          )}
          <Row>
            <UploadComponent
              id="formFile"
              labelText="Upload da Imagem*"
              setStateFunc={setImage}
              tipText="Tamanho 1754x1240"
            />
            {imageError && (
              <span className="text-danger">
                O campo Upload de Imagem é obrigatório
              </span>
            )}
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <SectionComponent
              sectionName="Configurações do Nome dos Participantes"
              setIsOpen={setCollapseIsOpen}
              isOpen={collapseIsOpen}
            />
          </Row>
          <Collapse isOpen={collapseIsOpen}>
            <Row>
              <Col md={6} style={{ paddingLeft: 0 }}>
                <label className="form-label" style={{ padding: 0 }}>
                  Tamanho da Fonte*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={fontSize}
                  onChange={(e) => setFontSize(e.target.value)}
                />
                {fontSizeError && (
                  <span className="text-danger">
                    O campo Tamanho da Fonte é obrigatório
                  </span>
                )}
              </Col>
              <Col md={6} style={{ padding: 0 }}>
                <label className="form-label" style={{ padding: 0 }}>
                  Alinhamento do Texto*
                </label>
                <select
                  className="form-control"
                  value={textAlignment}
                  onChange={(e) => setTextAlignment(e.target.value)}
                >
                  <option>Selecione</option>
                  <option>Esquerda</option>
                  <option>Centro</option>
                  <option>Direita</option>
                </select>
                {alignError && (
                  <span className="text-danger">
                    O campo Alinhamento do Texto é obrigatório
                  </span>
                )}
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col md={6} style={{ paddingLeft: 0 }}>
                <label className="form-label" style={{ padding: 0 }}>
                  Posição em Altura*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={heightPosition}
                  onChange={(e) => setHeightPosition(e.target.value)}
                />
                {heightError && (
                  <span className="text-danger">
                    O campo Posição em Altura é obrigatório
                  </span>
                )}
              </Col>
              <Col md={6} style={{ padding: 0 }}>
                <label className="form-label" style={{ padding: 0 }}>
                  Posição Largura*
                </label>
                <input
                  className="form-control"
                  type="number"
                  value={widthPosition}
                  onChange={(e) => setWidthPosition(e.target.value)}
                />
                {widthError && (
                  <span className="text-danger">
                    O campo Posição Largura é obrigatório
                  </span>
                )}
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <label className="form-label" style={{ padding: 0 }}>
                Cor*
              </label>
              <ColorPicker
                classOfContainer="colorpiker-certificate"
                labelText=""
                setStateFunc={setColor}
                defaultColor={color}
                position="top"
              />
            </Row>
          </Collapse>
          <Row
            style={{
              width: "100%",
              marginTop: 15,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}
